import { render } from "./CollectionPopover.vue?vue&type=template&id=070e6ef8&scoped=true"
import script from "./CollectionPopover.vue?vue&type=script&lang=js"
export * from "./CollectionPopover.vue?vue&type=script&lang=js"

import "./CollectionPopover.vue?vue&type=style&index=0&id=070e6ef8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070e6ef8"]])

export default __exports__